import layoutHeaderAside from '@/layouts/HeaderAside'

const meta = {
  auth: true
}
export default {
  path: '/contact',
  meta,
  component: layoutHeaderAside,
  children: [
    {
      path: '/contact/complaints',
      name: 'complaints',
      component: () => import('@/pages/contact/complaints.vue'),
      meta: {
        ...meta,
        title: '投诉建议',
        requireAuth: true
      }
    },
  ]
}
